<template>
  <div class="Icon" :style="{ width, height }">

    <svg class="Icon-svg" :style="{ fill }">

      <use :xlink:href="icon"></use>

    </svg>

  </div>
</template>

<script>
const ctx = require.context('icons', true, /\.svg$/)
const icons = {}

ctx.keys().forEach(key => {
  const name = key.replace('./', '').replace('.svg', '')
  icons[name] = ctx(key)
})

export default {
  name: 'Icon',

  props: {
    name: {
      type: String,
      required: true
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
    fill: {
      type: String
    }
  },

  computed: {
    icon () { return icons[this.name] }
  }
}
</script>

<style>
.Icon {

}

.Icon-svg {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// Icon.vue?98e780a4